import React from "react";
import { Container } from "react-bootstrap";

function Palestine() {
  return (
    <Container className="py-5">
      <h1>Palestine Reading List</h1>
      <p>
        This resource was created as part of our Lez Read Palestine online event
        in February 2024, and added to by our community.
      </p>

      <section className="mt-4">
        <h2>Updates and News</h2>
        <ul>
          <li>
            <a
              href="https://www.instagram.com/wizard_bisan1/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Bisan - Instagram
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/letstalkpalestine/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Let’s Talk Palestine bulletins - Instagram
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/middleeasteye/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Middle East Eye - Instagram
            </a>
          </li>
          <li>
            <a
              href="https://www.aljazeera.com/news/longform/2023/10/9/israel-hamas-war-in-maps-and-charts-live-tracker"
              target="_blank"
              rel="noopener noreferrer"
            >
              Al Jazeera live tracker - Website
            </a>
          </li>
          <li>
            <a
              href="https://twitter.com/GazaMartyrs"
              target="_blank"
              rel="noopener noreferrer"
            >
              Gaza Martyrs - Twitter
            </a>
          </li>
        </ul>
      </section>

      {/* Reading Lists */}
      <section className="mt-4">
        <h2>Reading Lists</h2>
        <ul>
          <li>
            <a
              href="https://palestinianfeministreading.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Palestinian feminist reading list - Website
            </a>
          </li>
          <li>
            <a
              href="https://www.haymarketbooks.org/blogs/71-free-palestine-a-reading-list"
              target="_blank"
              rel="noopener noreferrer"
            >
              Haymarket Books Free Palestine reading list - Website
            </a>
          </li>
          <li>
            <a
              href="https://www.plutobooks.com/free-palestine-reading-list/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Pluto Books Free Palestine reading list - Website
            </a>
          </li>
          <li>
            <a
              href="https://www.versobooks.com/en-gb/blogs/news/5078-palestinian-solidarity-reading-list"
              target="_blank"
              rel="noopener noreferrer"
            >
              Verso Books Palestinian Solidarity reading list - Website
            </a>
          </li>
          <li>
            <a
              href="https://palestinianyouthmovement.com/reading-list"
              target="_blank"
              rel="noopener noreferrer"
            >
              Palestinian Youth Movement reading list - Website
            </a>
          </li>
          <li>
            <a
              href="https://decolonizepalestine.com/reading-list/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Decolonize Palestine reading list - Website
            </a>
          </li>
        </ul>
      </section>

      {/* Literature Related */}
      <section className="mt-4">
        <h2>Literature Related</h2>
        <ul>
          <li>
            <a
              href="https://justworldbooks.com/books-by-title/gaza-writes-back/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Gaza Writes Back - Website
            </a>
          </li>
          <li>
            <a
              href="https://www.dailykos.com/stories/2023/10/19/2200384/-A-writer-from-Gaza-remembers"
              target="_blank"
              rel="noopener noreferrer"
            >
              A writer from Gaza remembers - Article
            </a>
          </li>
          <li>
            <a
              href="https://commapress.co.uk/books/palestine-100"
              target="_blank"
              rel="noopener noreferrer"
            >
              Comma Press Palestine +100 - Website
            </a>
          </li>
          <li>
            <a
              href="https://publishersforpalestine.org/2024/02/13/poems-for-palestine-chapbook-launch/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Poems for Palestine - Free Chapbook
            </a>
          </li>
          <li>
            <a
              href="https://lithub.com/these-are-the-poets-and-writers-who-have-been-killed-in-gaza/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Poets and writers killed in Gaza - Article
            </a>
          </li>
          <li>
            <a
              href="https://hilaked.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Friends of Israel: The Backlash against Palestine Solidarity - Hil
              Aked
            </a>
          </li>
          <li>
            <a
              href="https://www.poetryfoundation.org/poets/mahmoud-darwish#tab-poems"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mahmoud Darwish poems - The Poetry Foundation
            </a>
          </li>
          <li>
            <a
              href="https://www.aljazeera.com/features/2021/6/8/as-the-bombs-fall-i-write-the-poets-of-gaza"
              target="_blank"
              rel="noopener noreferrer"
            >
              Poets of Gaza feature - Al Jazeera
            </a>
          </li>
          <li>
            <a
              href="https://www.youtube.com/watch?v=_X6AneB7dPc"
              target="_blank"
              rel="noopener noreferrer"
            >
              Sally Rooney reads Letter from Gaza - YouTube
            </a>
          </li>
          <li>
            <a
              href="https://www.theatlantic.com/culture/archive/2023/12/poets-palestine/676928/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Poets of Palestine everyone should read - The Atlantic
            </a>
          </li>
          <li>
            <a
              href="https://time.com/6554381/poet-palestine-gaza-war/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Power of poetry in Palestine - TIME
            </a>
          </li>
          <li>
            <a
              href="https://time.com/6344843/refaat-alareer-killed-poet-gaza-notes/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Refaat Alareer - Last Gaza notes
            </a>
          </li>
          <li>
            <a
              href="https://www.theguardian.com/world/2023/dec/12/israel-hamas-war-palestinian-poetry-gaza"
              target="_blank"
              rel="noopener noreferrer"
            >
              Poetry as protest in Palestine - The Guardian
            </a>
          </li>
        </ul>
      </section>

      {/* Self Care */}
      <section className="mt-4">
        <h2>Self Care</h2>
        <ul>
          <li>
            <a
              href="https://www.youtube.com/watch?v=QQz5yVkBm5w"
              target="_blank"
              rel="noopener noreferrer"
            >
              Eight Keys to Trauma Recovery - Self-help guide to compassionate
              recovery from trauma
            </a>
          </li>
          <li>
            <a
              href="https://philome.la/jace_harr/you-feel-like-shit-an-interactive-self-care-guide/play/index.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              You Feel Like Sh*t - An Interactive Self-Care Guide
            </a>
          </li>
        </ul>
      </section>
    </Container>
  );
}

export default Palestine;
